// assets/alpine-store.js

document.addEventListener('alpine:init', () => {
    Alpine.store('global', {
        menuOpen: false, 
        searchOpen: false, 
        basketOpen: false, 
        authOpen: false, 
        atTop: true,
        bagBump: false, // Animasyon tetikleyici

        cartData: { item_count: 0, items: [] },
        updatingItemKey: null,
        isRemovingLastItem: false, // YENİ: Son eleman silinirken sağ tarafı anında gizlemek için

        notifications: [],

        init() {
            this.fetchCart();
        },

        async fetchCart() {
            try {
                const response = await fetch('/cart.js');
                this.cartData = await response.json();
            } catch (error) {
                console.error('Cart fetch error:', error);
            }
        },
        
        // Şablonun (bag-drawer) beklediği isimler
        get bag() { return this.cartData.items || []; },
        get bagCount() { return this.cartData.item_count || 0; },

        async addToBag(payload) {
            // Line item properties temizliği: null, undefined veya boş string'leri filtrele
            const cleanProperties = payload.properties ? Object.fromEntries( Object.entries(payload.properties).filter(([_, v]) => v !== null && v !== undefined && String(v).trim() !== '') ) : {};

            try {
                const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [{
                    id: Number(payload.id),
                    quantity: parseInt(payload.quantity, 10) || 1,
                    ...(Object.keys(cleanProperties).length > 0 && { properties: cleanProperties })
                    }]
                })
                });

                const data = await response.json();

                if (!response.ok) {
                // Shopify Storefront API hata formatı: { status: 422, message: "...", description: "..." }
                const errorMessage = data.description || data.message || 'Could not add item to bag.';
                this.pushNotification(errorMessage, 'error');
                return false; // Başarısızlık durumunu çağıran yere bildir
                }

                // Sepet verisini sunucuyla senkronize et
                await this.fetchCart();

                // Trigger haptic/bump animasyonu (timer çakışmasını önlemek için requestAnimationFrame)
                this.bagBump = false;
                requestAnimationFrame(() => { this.bagBump = true; });
                setTimeout(() => { this.bagBump = false; }, 300);

                // Başarılı bildirim toast'u
                this.pushNotification(payload.title || 'Item added to bag', 'success');
                return true;

            } catch (error) {
                console.error('addToBag network error:', error);
                this.pushNotification('A network error occurred. Please try again.', 'error');
                return false;
            }
            },

            // Bildirim oluşturma mantığını metod olarak izole ediyoruz (Tek sorumluluk ilkesi)
            pushNotification(message, type = 'success') {
            const id = typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`;
            this.notifications.push({ id, message, type });

            setTimeout(() => {
                this.notifications = this.notifications.filter(n => n.id !== id);
            }, 4000);
        },

        async changeQuantity(lineKey, quantity) {
            this.updatingItemKey = String(lineKey);
            
            // EĞER: Adet 0'a çekiliyorsa VE sepette tek ürün varsa, bayrağı kaldır
            if (quantity === 0 && this.cartData.item_count === 1) {
                this.isRemovingLastItem = true;
            }

            try {
                const apiRequest = fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: lineKey, quantity: quantity })
                });

                const minimumDelay = new Promise(resolve => setTimeout(resolve, 400));
                const [response] = await Promise.all([apiRequest, minimumDelay]);
                
                if (response.ok) {
                    await this.fetchCart();
                }
            } catch (error) {
                console.error('Change quantity error:', error);
            } finally {
                this.updatingItemKey = null;
                this.isRemovingLastItem = false; // İşlem bitince bayrağı sıfırla
            }
        },
    });
});